export default __webpack_public_path__ + "static/media/gallery-wip-clamp-lever_22.a13873ef.jpg";